import * as XLSX from "xlsx";
import { gridFilteredSortedRowEntriesSelector } from "@mui/x-data-grid";
import { formatNumber } from '../../../reducer/actions/formatNumber';
import { formatPrice } from '../../../reducer/actions/formatPrice';

export const exportToXLSX = (rows: any, columns: any, apiRef: any, name: any, slice?:number) => {
  const columnHeaders = columns.map((col: any) => col.headerName);

  console.log(columns);

  // 📌 Csak a szűrt és látható sorokat vesszük figyelembe
  const filteredSortedRowsAndIds = gridFilteredSortedRowEntriesSelector(apiRef);
  const visibleRows = filteredSortedRowsAndIds
    .filter((row: any) => row?.model?.name !== 'activity')
    .map((row: any) => row?.model);

  // 📌 Sorok átalakítása XLSX formátumra
  const worksheetData = visibleRows.map((row: any) => {
    return columns.slice(slice ? slice : 2).reduce((acc: any, col: any) => {

      let cellValue = row[col.field];
      if (typeof cellValue === "object" && cellValue !== null) {

        if (Array.isArray(cellValue)) {
          cellValue = cellValue.map((item) => item.name).join(", ");
        } else {
          cellValue = cellValue.name || "";
        }

      }
      else if(cellValue && typeof cellValue === "string" && cellValue.includes('<span')) {

        const div = document.createElement('div');
        div.innerHTML = cellValue;
        cellValue = div.textContent || div.innerText || '';
      }

      acc[col.headerName] = cellValue ? cellValue : "";
      return acc;
    }, {});
  });

  // 📌 XLSX létrehozása
  const worksheet = XLSX.utils.json_to_sheet(worksheetData);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "DataGrid Export");

  const today = new Date();
  const yyyy = today.getFullYear();
  const mm = String(today.getMonth() + 1).padStart(2, '0'); // hónap 0-indexelt
  const dd = String(today.getDate()).padStart(2, '0');

  const formattedDate = `${yyyy}-${mm}-${dd}`;

  // 📌 Fájlnév generálása
  const filename = `${name}_${formattedDate}`;

  // 📌 XLSX fájl mentése
  XLSX.writeFile(workbook, `${filename}.xlsx`);
};
